/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DepartmentColumnChart from "./Charts/DepartmentColumnChart";

//Serivce
import ItemService from "../../../../services/commonService";
import LoaderSmall from "../../../../components/common/LoaderSmall";
import toast from "react-hot-toast";
import MachineColumnChart from "./Charts/MachineColumnChart";
// import UsersColumnChart from "./Charts/UsersColumnChart";
import UsersDurationColumnChart from "./Charts/UsersDurationColumnChart";
import { ComboboxField } from "../../../../common/formElements/ComboboxField";
import { getCurrentDate } from "../../../../common/Validations";
import DatePicker, { DateObject } from "react-multi-date-picker";

const YearPickerInput = ({ openCalendar, value }) => (
  <div className="jobcardYearPickerControl">
    <input
      type="text"
      value={value || ""}
      placeholder="Choose Year"
      onClick={openCalendar}
      readOnly
      aria-label="Year"
    />
    <button type="button" onClick={openCalendar} aria-label="Open year picker">
      <i className="bi bi-calendar3"></i>
    </button>
  </div>
);

const JobcardAnalyticsReports = () => {
  localStorage.setItem("menu", "JobcardAnalyticsReports");
  localStorage.setItem("submenu", "-");

  const [formInputs, setFormInputs] = useState({
    year: "",
    jobcardNumber: "",
  });

  const [jobcardListData, setJobcardListData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedJobcardData, setSelectedJobcardData] = useState("");
  const [jobcardListLoading, setJobcardListLoading] = useState(false);

  const [deparmentChartData, setDeparmentChartData] = useState("");
  const [deparmentChartDataStatus, setDeparmentChartDataStatus] =
    useState(false);

  const [machineChartData, setMachineChartData] = useState("");
  const [machineChartDataStatus, setMachineChartDataStatus] = useState(false);

  const [userDurationData, setUserDurationData] = useState("");
  const [userDurationDataStatus, setUserDurationDataStatus] = useState(false);

  // Deparment Chart
  const deparmentChart = async (code) => {
    setDeparmentChartDataStatus(true);

    let obj = { jobcard: code };

    await ItemService.departmentAnalyticsReports(obj).then((item) => {
      // console.log(">> dashboard res!", item);
      if (item?.status === 200) {
        setDeparmentChartData(item);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setDeparmentChartDataStatus(false);
  };

  // Machine Chart
  const machineChart = async (code) => {
    setMachineChartDataStatus(true);

    let obj = { jobcard: code };

    await ItemService.machineAnalyticsReports(obj).then((item) => {
      // console.log(">> dashboard res!", item);
      if (item?.status === 200) {
        setMachineChartData(item);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setMachineChartDataStatus(false);
  };

  // UserDuration Chart
  const userDurationChart = async (code) => {
    setUserDurationDataStatus(true);

    let obj = { jobcard: code };

    await ItemService.userDurationsReport(obj).then((item) => {
      // console.log(">> dashboard res!", item);
      if (item?.status === 200) {
        setUserDurationData(item);
      } else {
        setUserDurationData([]);
        toast.error("User Duration Not Found!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setUserDurationDataStatus(false);
  };

  const handleYearChange = (selectedDate) => {
    const pickerYear = selectedDate ? new DateObject(selectedDate) : null;
    const year = pickerYear?.year ? String(pickerYear.year) : "";

    setSelectedYear(pickerYear);
    setFormInputs((current) => ({
      ...current,
      year,
      jobcardNumber: current.year === year ? current.jobcardNumber : "",
    }));
    setDeparmentChartData("");
    setMachineChartData("");
    setUserDurationData("");
  };

  // Fetch jobcards only after a year is selected.
  useEffect(() => {
    let active = true;

    const loadJobcards = async () => {
      if (!formInputs.year) {
        setJobcardListData([]);
        setJobcardListLoading(false);
        return;
      }

      setJobcardListLoading(true);
      setJobcardListData([]);
      try {
        const item = await ItemService.getJobcardsByYear({
          year: Number(formInputs.year),
        });

        if (!active) return;
        if (item?.status === 200) {
          setJobcardListData(item.data || []);
        } else {
          toast.error(item?.message || "Unable to load jobcards", {
            duration: 4000,
            position: "top-right",
          });
        }
      } catch (error) {
        if (active) {
          toast.error("Unable to load jobcards", {
            duration: 4000,
            position: "top-right",
          });
        }
      } finally {
        if (active) setJobcardListLoading(false);
      }
    };

    loadJobcards();
    return () => {
      active = false;
    };
  }, [formInputs.year]);

  useEffect(() => {
    setFormInputs((current) => ({
      ...current,
      jobcardNumber: selectedJobcardData?.name || "",
    }));
  }, [selectedJobcardData]);

  // Search
  const handleSerach = async () => {
    if (formInputs.jobcardNumber) {
      await deparmentChart(formInputs.jobcardNumber);
      await machineChart(formInputs.jobcardNumber);
      await userDurationChart(formInputs.jobcardNumber);
    } else {
      toast.error("Please Select the jobcard", {
        duration: 4000,
        position: "top-right",
      });
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Row>
              <Col xs={12} md={7}>
                <h2 className="mainTitle">
                  Jobcard Analytics -
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {getCurrentDate()}
                  </span>
                </h2>
                <p className="subText my-0">Jobcard Analytics detailed page</p>
              </Col>
              <Col xs={4} md={2}>
                <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
                  Year
                </label>
                <DatePicker
                  onlyYearPicker
                  format="YYYY"
                  value={selectedYear}
                  onChange={handleYearChange}
                  render={<YearPickerInput />}
                  containerClassName="jobcardYearPicker"
                />
              </Col>
              <Col xs={6} md={2}>
                <ComboboxField
                  label="Select Jobcard"
                  placeholder={
                    jobcardListLoading
                      ? "Loading Jobcards..."
                      : formInputs.year
                        ? "Please Select Jobcard"
                        : "Pick Year First"
                  }
                  data={jobcardListData}
                  id="jobcardNumber"
                  iconClassName="dropdownIcon"
                  name="jobcardNumber"
                  setValue={formInputs?.jobcardNumber}
                  getvalue={setSelectedJobcardData}
                  className="dropdownOption"
                  disabled={!formInputs.year || jobcardListLoading}
                />
              </Col>
              <Col xs={2} md={1} className="px-4">
                <button className="btnTable mt-4" onClick={handleSerach}>
                  <i className="bi bi-search"></i>
                </button>
              </Col>
            </Row>
            <hr />

            <section className="section">
              <div className="row">
                {/* Department */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Department</h5>
                      <LoaderSmall isLoading={deparmentChartDataStatus} />
                      <h6>
                        {!deparmentChartDataStatus ? (
                          <DepartmentColumnChart
                            key="department"
                            chartdata={deparmentChartData}
                          />
                        ) : (
                          ""
                        )}
                      </h6>
                    </div>
                  </div>
                </div>

                {/* Machines */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Machines and Users</h5>
                      <LoaderSmall isLoading={machineChartDataStatus} />
                      <h6>
                        {!machineChartDataStatus ? (
                          <MachineColumnChart
                            key="machine"
                            chartdata={machineChartData}
                          />
                        ) : (
                          ""
                        )}
                      </h6>
                    </div>
                  </div>
                </div>

                {/* Users Duration*/}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">User Duration</h5>
                      <LoaderSmall isLoading={userDurationDataStatus} />
                      <h6>
                        {!userDurationDataStatus ? (
                          <UsersDurationColumnChart
                            key="user-duration"
                            chartdata={userDurationData}
                          />
                        ) : (
                          ""
                        )}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default JobcardAnalyticsReports;
